/**
 * 🚨 This file is generated by scripts/zendesk.ts. Don't modify it manually!
 */
export const thirdPartyCustomFieldsMap = {
  Status: { prod: 360013721953, nonProd: "NA" },
  Group: { prod: 360013722013, nonProd: 360004390118 },
  Assignee: { prod: 360013722033, nonProd: 376888316957 },
  "Customers first name": { prod: 360006712378, nonProd: 360010706397 },
  "Surname  (as it appears on ID)": {
    prod: 360026751773,
    nonProd: 360010709557,
  },
  "Last 4 digits": { prod: 360006081238, nonProd: 360010709017 },
  "Mobile Number": { prod: 360006010038, nonProd: 360010707337 },
  DOB: { prod: 360022862154, nonProd: 360010707057 },
  "Relationship to account (without ATP)": {
    prod: 360014265218,
    nonProd: 360025274958,
  },
  "Security question": { prod: 360006239578, nonProd: 360010667978 },
  "Date field": { prod: 360006271577, nonProd: "NA" },
  "Value field": { prod: 360006271557, nonProd: "NA" },
  "Product(s) ": { prod: 360006143778, nonProd: 360010670358 },
  "add or remove an authorised party?": {
    prod: 360006365097,
    nonProd: 360010666998,
  },
  "Removal type": { prod: 360006387777, nonProd: 360010666838 },
  "Adding a Power of Attorney, a Legally Appointed Guardian or Administrator as an Authorised Third Party?":
    { prod: 360006331378, nonProd: 360010670978 },
  "Authority level": { prod: 360006365397, nonProd: 360010708837 },
  " Primary contact": { prod: 360006331698, nonProd: 360010666118 },
  "Organisation or Financial Counsellor?": {
    prod: 360006331738,
    nonProd: 360010668038,
  },
  "Hardship: Organisation or Financial Counsellor name": {
    prod: 360006159218,
    nonProd: 360010708957,
  },
  "Contact name": { prod: 360006389537, nonProd: 360010670058 },
  "Full Name ": { prod: 360006389577, nonProd: 360010706917 },
  "ATP or POA Full Name": { prod: 360006032317, nonProd: 360010667918 },
  "DOB 2": { prod: 360006357698, nonProd: 360010707737 },
  Phone: { prod: 360006389557, nonProd: 360010706117 },
  Address: { prod: 360005089238, nonProd: 360010708997 },
  "Suburb or City": { prod: 360006142138, nonProd: 360010707437 },
  State: { prod: 360006357538, nonProd: 360010670198 },
  "Postcode AU/NZ": { prod: 360006163997, nonProd: 360010669798 },
  "TPA Email Address": { prod: 360008081918, nonProd: 360010706237 },
  "Account 1": { prod: 360006047677, nonProd: 360010707477 },
  "Account 2": { prod: 360006024338, nonProd: 360010705917 },
  "Account 3": { prod: 360006024358, nonProd: 360010666958 },
  "Account 4": { prod: 360006047697, nonProd: 360010708437 },
  "Account 5": { prod: 360006047717, nonProd: 360010670078 },
  "Other Information": { prod: 360022820474, nonProd: 360010669618 },
  Type: { prod: 360013721973, nonProd: "NA" },
  "Authorised Third Party (TPA)": { prod: 360005938937, nonProd: 360010666058 },
  "Privacy Acknowledgement": { prod: 360006023478, nonProd: 360010666398 },
  "Time spent last update (sec)": { prod: 360021307894, nonProd: "NA" },
  "Total time spent (sec)": { prod: 360021307874, nonProd: "NA" },
  "Email Contact ON FILE": { prod: 360005939057, nonProd: "NA" },
  "Mobile Contact ON FILE": { prod: 360005939037, nonProd: "NA" },
  "Account number ON FILE": { prod: 360004901638, nonProd: "NA" },
  "Product Name ON FILE": { prod: 360005938977, nonProd: "NA" },
  "Application ID ON FILE": { prod: 360005922518, nonProd: "NA" },
  "Account Position ON FILE": { prod: 360005807577, nonProd: "NA" },
  "Manual Input ON FILE": { prod: 360005796038, nonProd: "NA" },
  Subject: { prod: 360013721913, nonProd: "NA" },
  Description: { prod: 360013721933, nonProd: "NA" },
  Priority: { prod: 360013721993, nonProd: "NA" },
  "DMS IDV Image ID": { prod: 360008462438, nonProd: "NA" },
};
